import { TalisEngageSettingsTier } from '®app/settings/talis-engage/talis-engage-settings.state';
import { environment } from '®environments/environment';
import { RequiredItemImportanceLevels } from '®shared/config/feature-flags';

import { AppConfig } from './app-config';
import { ListReviewAndPublishMode } from './list-review-and-publish-mode';

/**
 * Fake app config for local development
 **/
export class AppConfigLocalDev extends AppConfig {
  apiEndpoint = environment.proxy
    ? 'https://shipshape.talis.local:4200/api/3'
    : 'https://rl.talis.local/3';
  beta = '/beta.html';
  error = '/error.html';
  isEmbeddedMode = false;
  ltiRelinkUrl = undefined;
  personaEndpoint = environment.proxy
    ? 'https://shipshape.talis.local:4200/persona/2'
    : 'https://persona.talis.local/2';
  personaOrigin = environment.proxy
    ? 'https://shipshape.talis.local:4200'
    : 'https://persona.talis.local';
  oauthAppId = 'shipshape-local-app';
  talisLoginProvider = 'tfsadminlocal';
  // public key: https://dashboard.outbound.io/dashboard/settings/environments
  zendeskOutboundKey = 'CHANGE_ME';
  bookmarkingExtensionUrl =
    'https://support.talis.com/hc/en-gb/articles/17338752211485';
  session = {
    isAnLti1p0EmbeddedSession:
      new URL(window.location.href).searchParams.get('embed') === 'true',
    lti1p3LaunchId: new URL(window.location.href).searchParams.get(
      'lti1p3LaunchId',
    ),
    lti1p3LaunchType:
      new URL(window.location.href).searchParams
        .get('lti1p3LinkType')
        ?.split('-')[0] ?? undefined,
    lti1p3LinkResolutionDetails:
      new URL(window.location.href).searchParams
        .get('lti1p3LinkType')
        ?.split('-')[1] ?? undefined,
  };
  tenant = {
    anonymousAccessToken: undefined,
    conceptBaseUri: 'http://life.ac.uk',
    featureFlags: {
      isAddFromWorksEnabled: true,
      isDigitisationWorkflowEnabled: true,
      isMisDashboardEnabled: true,
      isReportBrokenLinkEnabled: true,
      reviewWorkflow: ListReviewAndPublishMode.REVIEW_AND_PUBLISH,
      isMusicScoresDigitisationEnabled: true,
      discoverySystemId: null,
      isAutofillProfileEnabled: false,
      isCourseReserveWorkflowEnabled: true,
      isCourseFlowTenancy: false,
      requiredItemImportances: RequiredItemImportanceLevels.OFF,
      isUnstableResourceTypesEnabled: true,
      fileUploadToReadingListCustomerTier: TalisEngageSettingsTier.TADC,
      isV2BookmarkingFlowEnabled: false,
      isV2EditExistingResourceEnabled: false,
    },
    library: {
      hideDoiLinks: false,
      isOpenUrlLinkingEnabled: true,
    },
    hierarchy: {
      isHierarchyUpdateEnabled: true,
    },
    httpsBaseUri: environment.proxy
      ? 'https://shipshape.talis.local:4200'
      : 'https://life.rl.talis.local',
    name: 'University of Life',
    roleMapping: {
      admin: [
        'admin-branding',
        'request-rollover',
        'upload-hierarchy',
        'resource-metadata-refresh',
        'grant-this-role',
        'access-keys',
        'lti-debug',
        'administer-settings',
        'access-tagging',
      ],
      libraryacquisitions: [
        'view-acquisitions',
        'receive-new-review-requests-by-email',
      ],
      listcreator: ['create-list'],
      listpub: [
        'edit-list',
        'publish-list',
        'grant-this-role',
        'list-access-control',
        'request-digitisation',
        'request-review',
        'archive-list',
        'view-reports',
        'attach-list-to-node',
        'assign-license',
        'delete-list',
        'request-course-reserve',
        'upload-file-to-list',
      ],
      publishonly: [
        'publish-list',
        'grant-this-role',
        'list-access-control',
        'request-digitisation',
        'request-review',
        'archive-list',
        'view-reports',
        'attach-list-to-node',
        'assign-license',
      ],
      nodeeditor: ['edit-node', 'attach-list-to-node', 'grant-this-role'],
      roleadmin: [
        'grant-any-role',
        'idp-migration',
        'request-rollover',
        'resource-metadata-refresh',
      ],
      v2listadmin: ['v2-configure-list-beta', 'v2-list-view'],
      v2listedit: ['v2-list-edit'],
      taggingbeta: ['access-tagging'],
    },
    roleCodesByRoleId: {
      'list-publisher': 'listpub',
    },
    shortCode: 'life',
    v2DashboardEnabled: undefined,
    reviewsUrl: 'http://critic.talis.local/life/reviews',
    elevateApiUrl: 'https://elevate.talis.local/1',
    discoverySystems: [
      {
        id: 'GUID1',
        type: 'primo',
        base_url: 'https://rl.talis.local/discovery/1/life/primo/GUID1/search',
      },
      {
        id: 'GUID2',
        type: 'eds',
        base_url: 'https://rl.talis.local/discovery/1/life/eds/GUID2/search',
      },
      {
        id: 'GUID3',
        type: 'worldcat',
        base_url:
          'https://rl.talis.local/discovery/1/life/worldcat/GUID3/search',
      },
      {
        id: 'GUID4',
        type: 'summon',
        base_url: 'https://rl.talis.local/discovery/1/life/summon/GUID4/search',
      },
    ],
  };
}
